import {
  COSTS_RETENTION,
  COSTS_MEASUREMENTS,
  COSTS_RENT,
  COSTS_GJ,
} from '../config/constants';

/**
 * Calculate the heat in GigaJoule (GJ) from the amount of gas in cubic meters (m3).
 * The number 32.677 is a constant to calculate m3 to GJ.
 */
export const m3toGJ = (m3: number): number => (
  m3 / 32.677
);

export const calculateAnnualGasPrice = (consumption: number, price: number): number => (
  consumption * price
);

export const calculateAnnualHeatPrice = (consumption: number, price: number): number => (
  m3toGJ(consumption) * (price || COSTS_GJ)
);

export const calculateAnnualFixedCost = (gridManagementCost: number, fixedCost: number): number => (
  gridManagementCost + fixedCost
);

export const calculateCvMaintenanceCost = (): number => (
  COSTS_MEASUREMENTS + COSTS_RENT
);

export const calculateTotalAnnualGasPrice = (
  consumption: number,
  price: number,
  gridManagementCost: number,
  fixedCost: number,
  cvMaintenanceCost: number,
  cvInstallationCost: number,
): number => {
  let total = gridManagementCost + fixedCost + cvMaintenanceCost + cvInstallationCost;
  total += consumption * price;

  return total;
};

export const calculateTotalAnnualHeatPrice = (consumption: number): number => {
  const consumptionGJ = m3toGJ(consumption);
  let total = COSTS_MEASUREMENTS + COSTS_RENT + COSTS_RETENTION;
  total += consumptionGJ * COSTS_GJ;

  return total;
};

export const calculateTotalMonthlyPrice = (annualPrice: number): number => (
  annualPrice / 12
);
